import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ExternalSettings } from './external-settings.interface';
import { ExternalSettingsService } from './external-settings.service';

@Injectable({
  providedIn: 'root'
})
export class ExternalSettingsResolver  {

  constructor(private srvExternalSettings : ExternalSettingsService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ExternalSettings> {
    return this.srvExternalSettings.externalSettings$.asObservable();
  }

}
